import BaseModel from "./BaseModel";
import moment from "moment";
import CommentAttachment from "./CommentAttachment";
import { writable } from "svelte/store";

class Comment extends BaseModel {
	constructor(data, attachToThread = null) {
		super({}, Comment.defaults);

		this.thread = attachToThread;

		this._attachments = [];
		this.lastUpdated = writable(Date.now());

		// this.data = data;
		this.setData(data);
	}

	addAttachment(attachment) {
		attachment.thread = this;
		this._attachments.push(attachment);
		this.lastUpdated.set(Date.now());
	}

	isNew() {
		return (typeof this.id === "undefined") || this.id === -1;
	}

	get id() {
		return this.get("id");
	}

	get attachments() {
		return this._attachments;
	}

	get message() {
		return this.get("message");
	}

	get fromUserName() {
		const dn = this.get("user_displayname");
		if (dn && dn.length > 0) {
			return dn;
		}
		return this.get("user_username");
	}

	get fromUserCompanyName() {
		return this.get("user_company_name");
	}

	get userId() {
		return this.get("user_id");
	}

	get timestamp() {
		return this.get("timestamp");
	}

	get relativeTime() {
		return moment(this.timestamp * 1000).fromNow();
	}

	get fullTimestamp() {
		return moment(this.timestamp * 1000).format("MMM Do YYYY HH:mm A");
	}

	update(data) {
		super.setData(data);
	}

	setData(data) {
		if (!data) {
			return;
		}
		super.setData(data);

		this._attachments = [];
		for (let i = 0; i < data.attachments.length; i++) {
			this.addAttachment(new CommentAttachment(data.attachments[i]));
		}
	}
}
Comment.defaults = { // Defaults
	id: -1,
	thread_id: -1,
	user_id: -1,
	user_username: "",
	user_displayname: "",
	user_company_name: "",
	message: "",
	attachments: [],
	timestamp: 0,
	removed: 0
};

export default Comment;
